export default "__VITE_ASSET__86877882__"